<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="content">

			<Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
				<!-- <FormItem label="分类等级" prop="level" class="sj">
					<Select v-model="formValidate.level" placeholder="请选择分类等级" @on-change="onchange" disabled>
						<Option value="1">一级</Option>
						<Option value="2">二级</Option>
					</Select>
				</FormItem> -->
				<!-- <FormItem label="一级分类" prop="parentId" class="sj" v-if="formValidate.level==2">
					<Select v-model="formValidate.parentId" placeholder="请选择一级分类">
						<Option :value="item.id"  v-for="(item,i) in types" :key="i">{{item.name}}</Option>
					</Select>
				</FormItem> -->
				<FormItem label="名称" prop="name" class="sj">
					<Input v-model="formValidate.name" placeholder="请输入名称"></Input>
				</FormItem>
				<FormItem label="图片" prop="value" class="sj" >
					<img style="max-width: 200ox;max-height: 200px;" :src="formValidate.url" />
				</FormItem>
				<FormItem label="重新上传" class="" >
					<Imgs @imgFile='imgFile' number='1' :url="url" />
				</FormItem>
				<FormItem label="说明" prop="typeExplain" class="sj">
					<Input v-model="formValidate.typeExplain" placeholder="请输入名称"></Input>
				</FormItem>
				<FormItem label="分成比例" prop="rake" class="sj"  v-if="formValidate.level==2">
					<Input v-model="formValidate.rake"  type="number" placeholder="请输入分成比例">
						<span slot="append" >/10000</span>
					</Input>
				</FormItem>
				
				<FormItem label="状态" prop="state" class="sj">
					<Select v-model="formValidate.state" placeholder="请选择类型状态">
						<Option value="true">启用</Option>
						<Option value="false">禁用</Option>
					</Select>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
					<Button @click="handleReset('formValidate')" style="margin-left: 8px">清空</Button>
				</FormItem>
			</Form>

		</div>
	</div>
</template>

<script>
	import http from '@/http/http.js'
	import Imgs from '@/components/comm/imgs.vue'
	export default {
		data() {
			return {
				url:"",
				types:[],
				query:{
					page:0,
					size:100,
					level:1,
					parentId:'',
					parentId:"",
					level:''
				},
				formValidate: {
					id:'',
					name: '',
					state: '',
					typeExplain:'',
					rake:'',
					img:''
				},
				ruleValidate: {
					level: [{
						required: true,
						message: '分类等级不能为空！！！',
						trigger: 'blur'
					}],
					name: [{
						required: true,
						message: '名称不能为空！！！',
						trigger: 'blur'
					}],
					state: [{
						required: true,
						message: '状态不能为空！！！',
						trigger: 'blur'
					}],
					typeExplain: [{
						required: true,
						message: '类型说明不能为空！！！',
						trigger: 'blur'
					}],
					rake: [{
						required: true,
						message: '分成比例不能为空！！！',
						trigger: 'blur'
					}]
				}

			}
		},
		
		 
		 components:{
		 	Imgs
		 },
		methods: {
			imgFile(files) {
				console.log(files)
				this.formValidate.img = files.substr(0, files.length - 1);
				if (this.formValidate.img.length > 0) {
					this.imgBool = false
				} else {
					this.imgBool = true
				}
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			handleSubmit(name) {
				let _this=this
				this.$refs[name].validate((valid) => {
					if (valid) {
						http.http({
						    //这里是你自己的请求方式、url和data参数
						    method: 'post',
						    url: http.url + '/oper/operComType/update/oper',
						    data: _this.formValidate,
							_this: _this,
							success: function(data) {
								_this.$Message.success('修改成功!');
							}
						    //假设后台需要的是表单数据这里你就可以更改
						  })
						
					} else {
						this.$Message.error('请完善信息后再进行提交!');
					}
				})
			},
			handleReset(name) {
				this.$refs[name].resetFields();
			},
			ajax() {
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/oper/operComType/findById',
				    data:{id: _this.formValidate.id},
					_this: _this,
					success: function(data) {
						_this.formValidate = data.data
						if (data.data.state == true) {
							_this.formValidate.state = "true"
						} else {
							_this.formValidate.state = "false"
						}
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
		},
		created() { //请求数据
			this.formValidate.id = this.$route.query.id
			this.ajax();
			
			let _this=this
			_this.url=http.url+"/file/img/com"
		},
		//设置返回不刷新数据
		beforeRouteLeave(to, from, next) {
			to.meta.keepAlive = true;
			next();
		}
	}
</script>

<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.sj {
		width: 400px !important;
	}

	.content {
		margin-left: 20%;

	}

	.content .nr {
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/oper/commodity/type/update.vue